export default __webpack_public_path__ + "static/media/banner-desktop.a5125f12.png";